import { Injectable } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { filter } from 'rxjs/operators';

export interface ParentMessage {
  type: string;
  path?: string;
}

@Injectable({
  providedIn: 'root'
})
export class ParentCommunicationService {
  private validOrigins = ['*']; // In production, should be restricted to specific origins

  constructor(private router: Router) {}

  init(): void {
    this.setupMessageListener();
    this.setupRouteChangeNotification();
    this.handleInitialRoute();
  }

  private setupMessageListener(): void {
    window.addEventListener('message', (event) => {
      if (!this.isValidOrigin(event.origin)) {
        return;
      }

      const message: ParentMessage = event.data;
      
      if (message.type === 'NAVIGATE_TO' && message.path) {
        this.router.navigate([message.path]);
      }
    });
  }

  private setupRouteChangeNotification(): void {
    this.router.events
      .pipe(filter(event => event instanceof NavigationEnd))
      .subscribe((event: NavigationEnd) => {
        this.notifyParentOfRouteChange(event.url);
      });
  }

  private notifyParentOfRouteChange(path: string): void {
    if (window.parent && window.parent !== window) {
      window.parent.postMessage({
        type: 'ANGULAR_NAVIGATION',
        path: path
      }, '*');
    }
  }

  private handleInitialRoute(): void {
    const currentPath = window.location.pathname;
    if (currentPath && currentPath !== '/') {
      this.notifyParentOfRouteChange(currentPath);
    }
  }

  private isValidOrigin(origin: string): boolean {
    return this.validOrigins.includes('*') || this.validOrigins.includes(origin);
  }
}